// ----------- Angular -----------
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
// ----------- Routing -----------
import { AppRoutingModule } from './app-routing.module';
// ----------- Firebase -----------
import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
// ----------- Material -----------
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
// ----------- Services -----------
import { RecordingsService } from './services/recordings.service';
import { ModalsService } from './services/modals.service';
import { AuthentificationService } from './services/authentification.service';
import { SortingService } from './services/sorting.service';
// ----------- Modals -----------
import { WarningsComponent } from './modals/warnings/warnings.component';
import { LoadingScreenComponent } from './modals/loading-screen/loading-screen.component';
import { PlayerComponent } from './main/player/player.component';
// ----------- Components -----------
import { AppComponent } from './app.component';
import { HeadComponent } from './header/head/head.component';
import { MyRecordingsComponent } from './main/myRecordings/myRecordings.component';
import { LoginComponent } from './main/login/login.component';
import { SidebarComponent } from './header/sidebar/sidebar.component';
import { CheckboxComponent } from './shared/checkbox/checkbox.component';
import { InputCommentComponent } from './shared/input-comment/inputComment.component';
import { NoRecordsComponent } from './main/myRecordings/no-records/no-records.component';

import { SearcherComponent } from './main/MyRecordings/searcher/searcher.component';
import { InputTitleComponent } from './shared/input-title/input-title.component';


// ----------- Production -----------
import {enableProdMode} from '@angular/core';
enableProdMode();

@NgModule({
  declarations: [
    AppComponent,
    MyRecordingsComponent,
    LoginComponent,
    HeadComponent,
    SidebarComponent,
    LoadingScreenComponent,
    CheckboxComponent,
    InputCommentComponent,
    WarningsComponent,
    NoRecordsComponent,
    PlayerComponent,
    SearcherComponent,
    InputTitleComponent,
  ],
  imports: [
    // ----------- Angular -----------
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    // ----------- Firebase -----------
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(environment.firebase),
    // ----------- Material -----------
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule
  ],
  providers: [
    // ----------- Firebase -----------
    AngularFireAuth,
    // ----------- Pipes -----------
    DatePipe,
    // ----------- Custom -----------
    RecordingsService,
    ModalsService,
    AuthentificationService,
    SortingService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts